'use strict'

import {Octokit} from '@octokit/core'

export default class Git {
  constructor (){
    this.octokit = new Octokit(
      {auth: process.env.VUE_APP_GIT_AUTH}
    );
  }

  /**
   * @return {Promise<void>}
   */
  async inviteUser (mail){
    await this.octokit.request('POST /orgs/{org}/invitations', {
      org: process.env.VUE_APP_ORG,
      email: mail,
      role: 'direct_member',
    });
  }
}